// var grid_product_on_page = $('.grid-products-on-page');
// var next_url = grid_product_on_page.data('next-url');
// var grid_load_more_btn = $('.grid-load-more__btn');
// var grid_load_more_spinner =  $('.grid-load-more__spinner');

// function gridLoadMore(){
//   $.ajax({
//     url : next_url,
//     type  : 'GET',
//     dataType : 'html',
//     beforeSend : function(){
//       grid_load_more_btn.hide();
//       grid_load_more_spinner.show();
//     }
//   }).done(function(next_page){
//     grid_load_more_spinner.hide();
//     var new_products = $(next_page).find('.grid-products-on-page');
//     next_url = new_products.data('next-url');
//     next_url = next_url;
//     if(next_url){
//       grid_load_more_btn.show();
//     }
//     grid_product_on_page.append(new_products.html());
//   });
// }













// var list_product_on_page = $('.list-products-on-page');
// var list_next_url = list_product_on_page.data('next-url');
// var list_load_more_btn = $('.list-load-more__btn');
// var list_load_more_spinner =  $('.list-load-more__spinner');
// function listLoadMore(){

//   $.ajax({
//     url : list_next_url,
//     type  : 'GET',
//     dataType : 'html',
//     beforeSend : function(){
//       list_load_more_btn.hide();
//       list_load_more_spinner.show();
//     }
//   }).done(function(next_page){
//     list_load_more_spinner.hide();
//     var new_products = $(next_page).find('.list-products-on-page');
//     list_next_url = new_products.data('next-url');
//     list_next_url = list_next_url;
//     if(list_next_url){
//       list_load_more_btn.show();
//     }
//     list_product_on_page.append(new_products.html());
//   });

// }


// ==============================================================================
// ==============================================================================





// GRID VIEW
var grid_product_on_page = $('.grid-products-on-page');
var next_url = grid_product_on_page.data('next-url');
var grid_load_more_btn = $('.grid-load-more__btn');
var grid_load_more_spinner = $('.grid-load-more__spinner');

function gridLoadMore() {
  console.log('▶️ Grid Load More clicked. Current next_url:', next_url);

  if (!next_url) {
    console.warn('⚠️ No next_url found. Stopping load.');
    return;
  }

  $.ajax({
    url: next_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function () {
      console.log('⏳ Sending grid AJAX request...');
      grid_load_more_btn.hide();
      grid_load_more_spinner.show();
    }
  }).done(function (next_page) {
    grid_load_more_spinner.hide();

    var new_products = $(next_page).find('.grid-products-on-page');

    if (!new_products.length) {
      console.warn('⚠️ No new .grid-products-on-page found in response');
      return;
    }

    var items = new_products.find('.grid__item');
    console.log('📦 New grid items found:', items.length);

    // Append new products
    grid_product_on_page.append(items);

    // Update next_url after appending
    next_url = new_products.data('next-url');
    console.log('🔁 Updated grid next_url:', next_url);

    if (next_url) {
      grid_load_more_btn.show();
    } else {
      console.log('✅ No more grid pages to load.');
    }
  }).fail(function (err) {
    console.error('❌ Grid AJAX error:', err);
  });
}

// LIST VIEW
var list_product_on_page = $('.list-products-on-page');
var list_next_url = list_product_on_page.data('next-url');
var list_load_more_btn = $('.list-load-more__btn');
var list_load_more_spinner = $('.list-load-more__spinner');

function listLoadMore() {
  console.log('▶️ List Load More clicked. Current next_url:', list_next_url);

  if (!list_next_url) {
    console.warn('⚠️ No list_next_url found. Stopping load.');
    return;
  }

  $.ajax({
    url: list_next_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function () {
      console.log('⏳ Sending list AJAX request...');
      list_load_more_btn.hide();
      list_load_more_spinner.show();
    }
  }).done(function (next_page) {
    list_load_more_spinner.hide();

    var new_products = $(next_page).find('.list-products-on-page');

    if (!new_products.length) {
      console.warn('⚠️ No new .list-products-on-page found in response');
      return;
    }

    var items = new_products.find('.grid__item');
    console.log('📦 New list items found:', items.length);

    // Append new products
    list_product_on_page.append(items);

    // Update next_url after appending
    list_next_url = new_products.data('next-url');
    console.log('🔁 Updated list next_url:', list_next_url);

    if (list_next_url) {
      list_load_more_btn.show();
    } else {
      console.log('✅ No more list pages to load.');
    }
  }).fail(function (err) {
    console.error('❌ List AJAX error:', err);
  });
}










